import Vue from "vue";
import Vuex from "vuex";
import * as R from "ramda";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogged: false,
    user: null,
  },
  mutations: {
    createSession(state, { token, user }) {
      localStorage.setItem("token", token);
      state.isLogged = true;
      state.user = user;
    },
    processLogout(state) {
      localStorage.removeItem("token");
      state.isLogged = false;
      state.user = {};
    },
  },
  getters: {
    userID: (state) => state.user.id,
    isLogged: (state) => state.isLogged,
    token: () => localStorage.getItem("token"),
    isSuper: ({ user }) => user.super,
    userPermissions: ({ user }) => user.permissions,
    shortName: ({ user }) =>
      `${user.names.split(" ")[0]} ${user.lastnames.split(" ")[0]}`,
  },
});
